export enum TimeUnit {
    DAY = "day",
    WEEK = "week",
    MONTH = "month",
    YEAR = "year"
}
